import normalizeThreadType from '@/lib/threads/normalizeThreadType.js';
import { MAIN_THREAD_TYPE_NOT_IN } from '@/lib/threads/threadTypeValues.js';

/* Types the main sidebar never lists: automation builders that own dedicated scopes, run shells,
   and subject-scoped threads a user reaches only through the thing they are about. */
const NON_MAIN_THREAD_TYPES = new Set(['schedule', 'trigger', ...MAIN_THREAD_TYPE_NOT_IN]);

const matchesThreadListScope = ({ thread, threadListScope }) => {
  const normalizedThreadListScope = String(threadListScope || '')
    .trim()
    .toLowerCase();
  const threadType = normalizeThreadType(thread?.threadType || thread?.thread_type, 'default');

  if (normalizedThreadListScope === 'main') {
    return !NON_MAIN_THREAD_TYPES.has(threadType);
  }

  if (normalizedThreadListScope === 'schedules') {
    return threadType === 'schedule';
  }

  if (normalizedThreadListScope === 'triggers') {
    return threadType === 'trigger';
  }

  if (normalizedThreadListScope === 'workflows') {
    return threadType === 'workflow' || threadType === 'workflow_requirements';
  }

  return false;
};

export default matchesThreadListScope;
